
import axios from 'axios';
import cookies from 'vue-cookies';
import router from '@/router/index';
import moment from 'moment';

const baseUrl = 'http://127.0.0.1:5000/';

const Report = {

  state: {
    buildingReports: {},
    activeReportBldgId: '',
    floorReports: {},
    activeReportFloorIndex: '',
    deviceReports: {},
    activeReportDeviceId: '',
    singleDeviceReports: {},
    nameplate: {}
  },

  getters: {

    getReport: state => () => {
      const reportArr = ['singleDevice', 'device', 'floor', 'building'];
      const populatedReports = reportArr.find(b => Object.keys(state[`${b}Reports`]).length);
      const reportIndex = reportArr.indexOf(populatedReports);
      let report = state[`${populatedReports}Reports`];
      report.img = ['doorWhite', 'tilesWhite', 'company', 'enterprise'][reportIndex];
      return report;
    },

    getReportEntity: state => () => {
      const reportArr = ['singleDevice', 'device', 'floor', 'building'];
      const entity = reportArr.find(b => Object.keys(state[`${b}Reports`]).length);
      return entity;
    },

    getStatePlate: state => () => {
      return state.nameplate;
    }

    // getBuildingReports: state => () => {
    //   return state.buildingReports;
    // },
    // getFloorReports: state => () =>  {
    //   return state.floorReports;
    // },
    // getDeviceReports: state => () => {
    //   return state.deviceReports;
    // }

  },

  mutations: {

    setBuildingReports(state, data){
      state.buildingReports = data;
      ['floor', 'device', 'singleDevice']
        .forEach(prop => state[`${prop}Reports`] = {});
      ['activeReportBldgId', 'activeReportFloorIndex', 'activeReportDeviceId']
        .forEach(prop => state[prop] = '');
      state.nameplate = {
        img: 'enterprise',
        dateRange: `${momentify(data.reports[0].tms)} ~ ${momentify(data.reports[data.reports.length - 1].tms)}`,
        // children: `${data.reports.length} ${data.reports}`
      }
      const children = data.reports.reduce((allChildren, report) => {
        if (!allChildren.includes(report.reportPK)) allChildren.push(report.reportPK);
        return allChildren
      }, []);
      ['name', 'country', 'city', 'state', 'street', 'zipCode']
        .forEach(prop => {
          if (data.entity[prop]) state.nameplate[prop] = data.entity[prop];
        });
      state.nameplate.children = `${children.length} Building${children.length == 1 ? '' : 's'}`
      console.log({STATEPLATE_FROM_STATE: state.nameplate});
    },

    setFloorReports(state, bldgReport){
      state.activeReportBldgId = bldgReport.alertPK;
      state.floorReports = bldgReport;
      console.log(state.floorReports);
    }

  },

  actions: {

    getOrgReports(context){
      return new Promise(async (resolve, reject) => {
        try {
          const report = await axios.get(baseUrl);
          context.commit('setBuildingReports', report.data);
          resolve();
        } catch (err) {
          console.log(err);
        }
      });
    },

    async navBuildingReport(context, bid){
      try {
        context.commit('setFloorReports', await axios.get(`${baseUrl}/${bid}`));
      } catch (err) {
        console.log(err);
      }
    }

  }

};

export default Report;

function momentify(tms){
  return moment(tms * 1000).format('MM/DD')
}



// WEBPACK FOOTER //
// ./src/store/report.js